import { gql } from 'graphql-request'

export const REMOVE_BOOK_BADGE = gql`
  mutation RemoveBookBadge($removeBadgeInput: RemoveBadgeInput!) {
    removeBookBadge(removeBadgeInput: $removeBadgeInput) {
      message
    }
  }
`
